/* eslint-disable import/no-named-default */
import React from 'react';
import PropTypes from 'prop-types';
import { default as DayPickerRDP } from 'react-day-picker';
import { withStyles } from '@material-ui/styles';
// import './calendarPicker.scss';
import NavbarMobile from './NavbarMobile';
import WeekHeaderMobile from './WeekHeaderMobile';

const DayPicker = ({ classes, ...rest }) => (
    <div className={classes.calendar}>
      <DayPickerRDP
        captionElement={<>-</>}
        navbarElement={<NavbarMobile />}
        weekdayElement={<WeekHeaderMobile />}
        {...rest}
      />
    </div>
  );

DayPicker.propTypes = {
  classes: PropTypes.object.isRequired,
};

const styles = () => ({
  calendar: {
    '& *:focus': {
      outline: 'none',
    },
    marginTop: '20px',
    '& .DayPicker': {
      width: '100%',
    },
  },
});
export default withStyles(styles)(DayPicker);
